module.exports = __webpack_public_path__ + "assetsclientes/img/google.41ff0a90.png";